import { render, staticRenderFns } from "./PromotionsArchiveDialog.vue?vue&type=template&id=89a87412&scoped=true&"
import script from "./PromotionsArchiveDialog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PromotionsArchiveDialog.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PromotionsArchiveDialog.vue?vue&type=style&index=0&id=89a87412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a87412",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89a87412')) {
      api.createRecord('89a87412', component.options)
    } else {
      api.reload('89a87412', component.options)
    }
    module.hot.accept("./PromotionsArchiveDialog.vue?vue&type=template&id=89a87412&scoped=true&", function () {
      api.rerender('89a87412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPromotions/components/PromotionsArchiveDialog.vue"
export default component.exports